import React, { useEffect, useState } from 'react';
import { Plus, X, Link2 } from 'lucide-react';
import { categoriesAPI } from '../services/api';

const selectCls = 'w-full border border-gray-300 rounded-md px-3 py-2 text-sm disabled:bg-gray-100 disabled:text-gray-400';
let cache = null;

// Admin article editor: category › subcategory pairs where this guide must be shown (product pages + category pages)
export const ArticleLinksField = ({ value, onChange }) => {
  const [categories, setCategories] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    categoriesAPI.getAll().then((l) => { cache = l; setCategories(l); }).catch(() => {});
  }, []);
  const rows = value || [];
  const update = (idx, patch) => onChange(rows.map((r, i) => (i === idx ? { ...r, ...patch } : r)));
  const remove = (idx) => onChange(rows.filter((_, i) => i !== idx));
  const add = () => {
    const first = categories.find((c) => !rows.some((r) => r.category === c.slug)) || categories[0];
    if (first) onChange([...rows, { category: first.slug, subcategory: '' }]);
  };
  return (
    <div className="border border-dashed border-gray-300 rounded-lg p-3 bg-gray-50" data-testid="article-links">
      <div className="flex items-center justify-between mb-2 gap-3">
        <div>
          <p className="text-xs font-medium text-gray-700 inline-flex items-center gap-1"><Link2 size={12} className="text-orange-500" /> Sous-catégories liées</p>
          <p className="text-[11px] text-gray-500">Ce guide s'affichera en priorité sur les fiches produit et les pages de ces (sous-)catégories. Sans sous-catégorie = toute la catégorie.</p>
        </div>
        <button type="button" onClick={add} disabled={!categories.length} data-testid="article-link-add" className="inline-flex items-center gap-1 text-xs font-medium text-orange-600 hover:text-orange-700 disabled:text-gray-400 whitespace-nowrap">
          <Plus className="w-3.5 h-3.5" /> Ajouter
        </button>
      </div>
      {rows.length === 0 && <p className="text-xs text-gray-400" data-testid="article-links-empty">Aucune liaison manuelle : détection automatique par le texte de l'article.</p>}
      <div className="space-y-2">
        {rows.map((row, idx) => {
          const subs = categories.find((c) => c.slug === row.category)?.subcategories || [];
          return (
            <div key={idx} className="grid grid-cols-1 sm:grid-cols-[1fr_1fr_auto] gap-2 items-center" data-testid={`article-link-row-${idx}`}>
              <select data-testid={`article-link-category-${idx}`} value={row.category} onChange={(e) => update(idx, { category: e.target.value, subcategory: '' })} className={selectCls}>
                {categories.map((c) => <option key={c.slug} value={c.slug}>{c.name}</option>)}
              </select>
              <select data-testid={`article-link-subcategory-${idx}`} value={row.subcategory || ''} onChange={(e) => update(idx, { subcategory: e.target.value })} disabled={subs.length === 0} className={selectCls}>
                <option value="">{subs.length === 0 ? 'Aucune sous-catégorie définie' : 'Toute la catégorie'}</option>
                {subs.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
              <button type="button" onClick={() => remove(idx)} data-testid={`article-link-remove-${idx}`} className="p-2 text-gray-400 hover:text-red-600" aria-label="Retirer"><X className="w-4 h-4" /></button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
